import React, { useState } from 'react';
import {
  Box,
  Button,
  TextField,
  Typography,
  Stack,
  InputLabel,
  MenuItem,
  Select,
  FormControl,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';

const ResendOfferForm = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [productImage, setProductImage] = useState(null);
  const [startDateTime, setStartDateTime] = useState(new Date());
  const [endDateTime, setEndDateTime] = useState(new Date());
  const [originalPrice, setOriginalPrice] = useState('');
  const [offerPrice, setOfferPrice] = useState('');
  const [productLink, setProductLink] = useState('');
  const [productName, setProductName] = useState('');
  const [platform, setPlatform] = useState('');

  const handleImageChange = (e) => {
    setProductImage(e.target.files[0]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!productImage) return alert('Please upload product image');

    const resellerId = localStorage.getItem('resellerId');
    if (!resellerId) return alert('Reseller not logged in');

    const formData = new FormData();
    formData.append('resellerId', resellerId);
    formData.append('productImage', productImage);
    formData.append('startDateTime', startDateTime.toISOString());
    formData.append('endDateTime', endDateTime.toISOString());
    formData.append('originalPrice', originalPrice);
    formData.append('offerPrice', offerPrice);
    formData.append('productLink', productLink);
    formData.append('productName', productName);
    formData.append('platform', platform);

    try {
      const res = await fetch('https://reviewhub-lc.onrender.com/api/resendoffers', {
        method: 'POST',
        body: formData,
      });

      const data = await res.json();
      if (!res.ok) {
        alert(data.message || 'Failed to submit offer.');
        return;
      }

      alert('Offer submitted successfully!');
    } catch (error) {
      console.error(error);
      alert('Failed to submit offer.');
    }
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <Box
        component="form"
        onSubmit={handleSubmit}
        sx={{
          maxWidth: 600,
          mx: 'auto',
          mt: 0,
          p: 0,
          borderRadius: 2,
        }}
      >


        <Stack spacing={1}>
          <FormControl fullWidth required>
            <InputLabel id="platform-label">Platform</InputLabel>
            <Select
              labelId="platform-label"
              id="platform"
              value={platform}
              onChange={(e) => setPlatform(e.target.value)}
              label="Platform"
            >
              <MenuItem value="Myntra">Myntra</MenuItem>
              <MenuItem value="Meesho">Meesho</MenuItem>
              <MenuItem value="Flipkart">Flipkart</MenuItem>
              <MenuItem value="Amazon">Amazon</MenuItem>
              <MenuItem value="Instagram">Instagram</MenuItem>
            </Select>
          </FormControl>

          <Box>
            <InputLabel sx={{ mb: 1 }}>Product Image</InputLabel>
            <input
              type="file"
              accept="image/*"
              onChange={handleImageChange}
              required
              style={{ width: '100%' }}
            />
          </Box>

          {/* DateTime Pickers - stacked on mobile */}
          <Box display="flex" flexDirection={isMobile ? 'column' : 'row'} gap={2}>
            <DateTimePicker
              label="Start Date & Time"
              value={startDateTime}
              onChange={setStartDateTime}
              renderInput={(params) => (
                <TextField {...params} fullWidth sx={{ mb: isMobile ? 2 : 0 }} />
              )}
            />
            <DateTimePicker
              label="End Date & Time"
              value={endDateTime}
              onChange={setEndDateTime}
              renderInput={(params) => <TextField {...params} fullWidth />}
            />
          </Box>

          {/* Price fields - stacked on mobile */}
          <Box display="flex" flexDirection={isMobile ? 'column' : 'row'} gap={2}>
            <TextField
              label="Original Price"
              type="number"
              value={originalPrice}
              onChange={(e) => setOriginalPrice(e.target.value)}
              fullWidth
              required
              sx={{ mb: isMobile ? 0 : 0 }}
            />
            <TextField
              label="Offer Price"
              type="number"
              value={offerPrice}
              onChange={(e) => setOfferPrice(e.target.value)}
              fullWidth
              required
            />
          </Box>

          {/* Product fields - stacked on mobile */}
          <Box display="flex" flexDirection={isMobile ? 'column' : 'row'} gap={2}>
            <TextField
              label="Product Name"
              value={productName}
              onChange={(e) => setProductName(e.target.value)}
              fullWidth
              required
              sx={{ mb: isMobile ? 0 : 0 }}
            />
            <TextField
              label="Product Link"
              value={productLink}
              onChange={(e) => setProductLink(e.target.value)}
              fullWidth
              required
            />
          </Box>

          <Button 
            variant="contained" 
            color="primary" 
            
            type="submit"
            size={isMobile ? 'large' : 'medium'}
            fullWidth
            sx={{ mt: 2 ,   backgroundColor: '#616161',}}
          >
            Submit Offer
          </Button>
        </Stack>
      </Box>
    </LocalizationProvider>
  );
};

export default ResendOfferForm;